<template>
  <div class="form-employee-work" role="group">
    <div class="form-employee-work__days__date-title">
      <div class="form-employee-work__days__date-wrapper">
        <span class="form-employee-work__days__text">Четные дни с:&nbsp;</span>
        <date-range-picker-dialog
          v-bind:value="evenOddDays.evenDays.startsDate"
          v-on:input="onInputEvenStartsDate"
        >
          <template v-slot:trigger="{ listenerObject }">
            <button
              class="form-employee-work__days__data"
              type="button"
              v-on="listenerObject"
            >{{ evenStartsDateTitle }}</button>
          </template>
        </date-range-picker-dialog>
      </div>
    </div>
    <div
      class="form-employee-work__row"
      v-for="(times, index) in evenOddDays.evenDays.workTimes"
      v-bind:key="`evenDays-${times.key}`"
    >
      <time-interval-picker
        class="form-employee-work__row"
        v-bind:initial-from="times.from"
        v-bind:initial-to="times.to"
        v-bind:time-set="suggestedHours"
        v-on:input-from="onInputEvenWorkTime(index, $event, times.to)"
        v-on:input-to="onInputEvenWorkTime(index, times.from, $event)"
      />
      <button
        v-if="index === 0"
        title="Добавить"
        class="form-employee-work__button-add"
        type="button"
        v-bind:disabled="evenOddDays.evenDays.workTimes.length >= maxWorkIntervalsInDay"
        v-on:click="onAddEvenWorkTimes()" />
      <button
        v-else
        class="form-employee-work__button-remove"
        title="Удалить"
        type="button"
        v-on:click="onRemoveEvenWorkTimes(index)" />
    </div>
    <div class="form-employee-work__days__date-title">
      <div class="form-employee-work__days__date-wrapper">
        <span class="form-employee-work__days__text">Нечетные дни с:&nbsp;</span>
        <date-range-picker-dialog
          v-bind:value="evenOddDays.oddDays.startsDate"
          v-on:input="onInputOddStartsDate"
        >
          <template v-slot:trigger="{ listenerObject }">
            <button
              class="form-employee-work__days__data"
              type="button"
              v-on="listenerObject"
            >{{ oddStartsDateTitle }}</button>
          </template>
        </date-range-picker-dialog>
      </div>
    </div>
    <div
      class="form-employee-work__row"
      v-for="(times, index) in evenOddDays.oddDays.workTimes"
      v-bind:key="`oddDays-${times.key}`"
    >
      <time-interval-picker
        class="form-employee-work__row"
        v-bind:initial-from="times.from"
        v-bind:initial-to="times.to"
        v-bind:time-set="suggestedHours"
        v-on:input-from="onInputOddWorkTime(index, $event, times.to)"
        v-on:input-to="onInputOddWorkTime(index, times.from, $event)"
      />
      <button
        v-if="index === 0"
        title="Добавить"
        class="form-employee-work__button-add"
        type="button"
        v-bind:disabled="evenOddDays.oddDays.workTimes.length >= maxWorkIntervalsInDay"
        v-on:click="onAddOddWorkTimes()" />
      <button
        v-else
        class="form-employee-work__button-remove"
        title="Удалить"
        type="button"
        v-on:click="onRemoveOddWorkTimes(index)" />
    </div>
  </div>
</template>
<script>
import DateRangePickerDialog from '@/components/DateRangePickerDialog.vue';
import TimeIntervalPicker from '@/components/TimeIntervalPicker.vue';

function WorkTimes(from, to, key) {
  this.from = from;
  this.to = to;
  this.key = key;
}

/**
 * @description Четные дни
 * @param {string} from       Часа начала работы.
 * @param {string} to         Часы окончания работы.
 * @param {Date}   startsDate Дата начала отсчета.
 * @param {any[]}  workTimes  Рабочие периоды.
 * @constructor
 */
export function EvenDays(
  from,
  to,
  startsDate = new Date(),
  workTimes = [new WorkTimes(from, to, Date.now())],
) {
  this.startsDate = startsDate;
  this.workTimes = workTimes;
}

/**
 * @description Нечетные дни
 * @param {string} from       Часа начала работы.
 * @param {string} to         Часы окончания работы.
 * @param {Date}   startsDate Дата начала отсчета.
 * @param {any[]}  workTimes  Рабочие периоды.
 * @constructor
 */
export function OddDays(
  from,
  to,
  startsDate = new Date(),
  workTimes = [new WorkTimes(from, to, Date.now())],
) {
  this.startsDate = startsDate;
  this.workTimes = workTimes;
}

/**
 * @description Четные нечетные дни
 * @param {EvenDays} evenDays Четные дни.
 * @param {OddDays}  oddDays  Нечетные дни.
 * @constructor
 */
export function EvenOddDays(
  evenDays = new EvenDays(),
  oddDays = new OddDays(),
) {
  this.evenDays = evenDays;
  this.oddDays = oddDays;
}

/**
 * @description Компонент выбора режима дни-через-дни.
 */
export default {
  components: {
    DateRangePickerDialog,
    TimeIntervalPicker,
  },
  computed: {
    evenStartsDateTitle: (vm) => {
      const options = {
        day: 'numeric',
        month: 'long',
      };
      return vm.evenOddDays.evenDays.startsDate.toLocaleDateString('ru-RU', options);
    },
    oddStartsDateTitle: (vm) => {
      const options = {
        day: 'numeric',
        month: 'long',
      };
      return vm.evenOddDays.oddDays.startsDate.toLocaleDateString('ru-RU', options);
    },
  },
  data() {
    return {
      evenOddDays: this.value,
    };
  },
  inject: ['maxWorkIntervalsInDay'],
  methods: {
    onAddEvenWorkTimes() {
      this.evenOddDays.evenDays.workTimes.push(
        new WorkTimes(this.initialFrom, this.initialTo, Date.now()),
      );
      this.onInput();
    },
    onRemoveEvenWorkTimes(timesIndex) {
      this.evenOddDays.evenDays.workTimes.splice(timesIndex, 1);
      this.onInput();
    },
    onAddOddWorkTimes() {
      this.evenOddDays.oddDays.workTimes.push(
        new WorkTimes(this.initialFrom, this.initialTo, Date.now()),
      );
      this.onInput();
    },
    onRemoveOddWorkTimes(dayIndex, timesIndex) {
      this.evenOddDays.oddDays.workTimes.splice(timesIndex, 1);
      this.onInput();
    },
    onInputEvenWorkTime(timesIndex, from, to) {
      const times = this.evenOddDays.evenDays.workTimes[timesIndex];
      times.from = from;
      times.to = to;
      this.onInput();
    },
    onInputOddWorkTime(timesIndex, from, to) {
      const times = this.evenOddDays.oddDays.workTimes[timesIndex];
      times.from = from;
      times.to = to;
      this.onInput();
    },
    onInputEvenStartsDate(value) {
      this.evenOddDays.evenDays.startsDate = value;
      this.$emit('input', this.evenOddDays);
    },
    onInputOddStartsDate(value) {
      this.evenOddDays.oddDays.startsDate = value;
      this.$emit('input', this.evenOddDays);
    },
    onInput() {
      this.$emit('input', this.evenOddDays);
    },
  },
  name: 'EvenOddDaysPicker',
  props: {
    value: {
      default: () => ({
        evenDays: new EvenDays(),
        oddDays: new OddDays(),
      }),
      type: Object,
    },
    /**
     * @description Предложенные часы работы.
     */
    suggestedHours: { default: () => [], type: Array },
    /**
     * @description Часы работы от.
     */
    initialFrom: { default: () => '00:00', type: String },
    /**
     * @description Часы работы до.
     */
    initialTo: { default: () => '00:00', type: String },
  },
  watch: {
    value(newValue) {
      this.evenOddDays = newValue;
    },
  },
};
</script>
<style scoped lang="scss">
@use "@/scss/buttons";

.form-employee-work {
  border: none;
  display: grid;
  align-items: center;
  gap: 10px 20px;
  padding: 0 0 0 34px;
  margin: 5px 0 20px 0;
  &__row {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
  }
  &__days {
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: 10px;
    &__date-title {
      flex-direction: row;
      width: 100%;
      font-size: 14px;
    }
    &__group {
      display: flex;
      flex-direction: column;
      gap: 10px;
      margin: 20px 0 0 0;
    }
    &__date-wrapper {
      display: flex;
      column-gap: 10px;
    }
    &__text {
      font-weight: 400;
      font-size: 14px;
      line-height: 14px;
    }
    &__data {
      color: var(--action-color);
      font-weight: 400;
      font-size: 14px;
      line-height: 14px;
    }
  }
  &__work-days {
    width: 90%;
  }
  &__button {
    &-add {
      text-align: left;
      color: #0489e0;
      font-weight: 400;
      font-size: 16px;
      line-height: 20px;
      @include buttons.btn-plus-color-add;
    }
    &-remove {
      text-align: left;
      color: var(--warning-color);
      font-weight: 400;
      font-size: 16px;
      line-height: 20px;
      @include buttons.btn-cross-color-remove;
    }
  }
  &__input {
    border: 1px solid #C2CFE0;
    box-sizing: border-box;
    border-radius: 4px;
    appearance: textfield;
    height: 40px;
    width: min(100%, 65px);
    min-width: 60px;
    padding: 10px;
    color: #707683;
    font-size: 16px;
    &:focus {
      color: #192a3e;
      background-color: #fff;
      border: 1px solid #0489e0 !important;
      outline: 0;
    }
    &:disabled {
      background-color: #fff;
    }
  }
}
</style>
